import * as React from "react";
import { FlightsViews } from "components/flexComponents/Flights/util/typings";
import { TripTypePill } from "components/flexComponents/Flights/components/TripTypePill";
import FilterPill from "components/flexComponents/Flights/components/FilterPill";
import { useLocalization } from "@shared-ui/localization-context";

export interface FlightsPillProps {
  id: string;
  availableMonths: number[];
  showMonthFilter?: boolean;
  view: string;
  filterOneWay: () => void;
  filterAllDeals: () => void;
  filterRoundTrip: () => void;
  filterByMonth: (month: number) => void;
  tripTypePillToggleState: string;
}

export const FlightsPill = (props: FlightsPillProps) => {
  const { formatText } = useLocalization();
  const {
    view,
    id,
    availableMonths,
    filterOneWay,
    filterAllDeals,
    filterRoundTrip,
    filterByMonth,
    showMonthFilter,
    tripTypePillToggleState,
  } = props;
  switch (view) {
    case FlightsViews.WITH_BUTTON:
    case FlightsViews.TRIP_TYPE: {
      return (
        <TripTypePill
          filterOneWay={filterOneWay}
          filterAllDeals={filterAllDeals}
          filterRoundTrip={filterRoundTrip}
          formatText={formatText}
          moduleId={id}
          tripTypePillToggleState={tripTypePillToggleState}
        />
      );
    }
    case FlightsViews.FILTERED: {
      return (
        <FilterPill
          formatText={formatText}
          filterByMonth={filterByMonth}
          filterAllDeals={filterAllDeals}
          availableMonths={availableMonths}
          showMonthFilter={showMonthFilter}
          moduleId={id}
        />
      );
    }
    default: {
      return null;
    }
  }
};

export default FlightsPill;
